

<br />
<br />
<div style="margin: 0 auto; width: 300px; height: 400px; border: 1px solid #ddd; padding: 30px; background-color: #fff">
  <form [formGroup]="changepwdForm" novalidate>
    <div style="text-align:center">
      <span style="font-size:x-large;font-weight:bold">修改密碼</span>
    </div>
    <br /><br />
    <label style="font-size:medium">新密碼</label>
    <br />
    <input formControlName="password" type="password" style="font-size: large; padding: 3px 10px; border: 1px solid #bbb; border-radius: 5px; width: 100%" />
    <br /><br />
    <label style="font-size:medium">確認密碼</label>
    <br />
    <input formControlName="passwordCheck" type="password" style="font-size: large; padding: 3px 10px; border: 1px solid #bbb; border-radius: 5px; width: 100%"  />
    <br /><br /><br />
    <div style="text-align:center">
      <button mat-raised-button color="primary" (click)="putChangepwd(changepwdForm.value)" matTooltip="修改密碼" style="width: 200px">送出</button>
    </div>
  </form>
</div>
